import { render, staticRenderFns } from "./CustomerLimit.vue?vue&type=template&id=83c2e378&scoped=true&"
import script from "./CustomerLimit.vue?vue&type=script&lang=js&"
export * from "./CustomerLimit.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLimit.vue?vue&type=style&index=0&id=83c2e378&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c2e378",
  null
  
)

export default component.exports